var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1668 19.9999C39.1668 30.5854 30.5856 39.1666 20.0002 39.1666C9.4147 39.1666 0.833496 30.5854 0.833496 19.9999C0.833496 9.41446 9.4147 0.833252 20.0002 0.833252C30.5856 0.833252 39.1668 9.41446 39.1668 19.9999Z",
    fill: "#D7F4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 15.4167C20.8333 18.8685 18.035 21.6667 14.5833 21.6667C11.1315 21.6667 8.33325 18.8685 8.33325 15.4167C8.33325 11.965 11.1315 9.16675 14.5833 9.16675C18.035 9.16675 20.8333 11.965 20.8333 15.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79541 31.6714L5.1183 31.0606C6.76752 27.4831 10.3854 25 14.5832 25C18.1748 25 21.3418 26.8177 23.2146 29.5833C24.8859 27.813 27.3732 26.6667 29.9999 26.6667C32.4358 26.6667 34.6498 27.6168 36.2915 29.1667L36.6367 29.5238C33.3313 35.2855 27.1188 39.1667 19.9999 39.1667C13.8066 39.1667 8.29931 36.2292 4.79541 31.6714Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 23.3333C32.7613 23.3333 34.9999 21.0947 34.9999 18.3333C34.9999 15.5718 32.7613 13.3333 29.9999 13.3333C27.2385 13.3333 24.9999 15.5718 24.9999 18.3333C24.9999 21.0947 27.2385 23.3333 29.9999 23.3333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0002 37.1666C29.481 37.1666 37.1668 29.4808 37.1668 19.9999C37.1668 10.519 29.481 2.83325 20.0002 2.83325C10.5193 2.83325 2.8335 10.519 2.8335 19.9999C2.8335 29.4808 10.5193 37.1666 20.0002 37.1666ZM20.0002 39.1666C30.5856 39.1666 39.1668 30.5854 39.1668 19.9999C39.1668 9.41446 30.5856 0.833252 20.0002 0.833252C9.4147 0.833252 0.833496 9.41446 0.833496 19.9999C0.833496 30.5854 9.4147 39.1666 20.0002 39.1666Z",
    fill: "#00A988"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5835 19.6667C16.9307 19.6667 18.8335 17.764 18.8335 15.4167C18.8335 13.0695 16.9307 11.1667 14.5835 11.1667C12.2363 11.1667 10.3335 13.0695 10.3335 15.4167C10.3335 17.764 12.2363 19.6667 14.5835 19.6667ZM14.5835 21.6667C18.0353 21.6667 20.8335 18.8685 20.8335 15.4167C20.8335 11.965 18.0353 9.16675 14.5835 9.16675C11.1317 9.16675 8.3335 11.965 8.3335 15.4167C8.3335 18.8685 11.1317 21.6667 14.5835 21.6667Z",
    fill: "#00A988"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5835 26C10.7902 26 7.51867 28.2429 6.02674 31.4793L4.21045 30.642C6.01696 26.7232 9.98116 24 14.5835 24C20.8887 24 26.0001 29.1114 26.0001 35.4167C26.0001 36.3597 25.8856 37.2773 25.6692 38.1559L23.7272 37.6775C23.9054 36.9543 24.0001 36.1972 24.0001 35.4167C24.0001 30.216 19.7842 26 14.5835 26Z",
    fill: "#00A988"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9998 27.6667C27.6595 27.6667 25.5505 28.6498 24.0603 30.2283L22.606 28.8554C24.4583 26.8933 27.0866 25.6667 29.9998 25.6667C32.7009 25.6667 35.1579 26.7215 36.9778 28.4396L35.6049 29.8939C34.1414 28.5123 32.1704 27.6667 29.9998 27.6667Z",
    fill: "#00A988"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 21.3333C31.6569 21.3333 33 19.9901 33 18.3333C33 16.6764 31.6569 15.3333 30 15.3333C28.3431 15.3333 27 16.6764 27 18.3333C27 19.9901 28.3431 21.3333 30 21.3333ZM30 23.3333C32.7614 23.3333 35 21.0947 35 18.3333C35 15.5718 32.7614 13.3333 30 13.3333C27.2386 13.3333 25 15.5718 25 18.3333C25 21.0947 27.2386 23.3333 30 23.3333Z",
    fill: "#00A988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.23c78ab9fa47393035ab7d7fe0bfc190.svg";
export { ForwardRef as ReactComponent };